import React from 'react';
import { XMarkIcon } from '@heroicons/react/20/solid';
import { Link } from 'react-router-dom';

interface MenuItem {
  label: string;
  href?: string;
}

interface MobileNavigationProps {
  menuItems: MenuItem[];
  isMobileMenuOpen: boolean;
  onCloseMobileMenu: () => void;
  isActiveItem: (item: MenuItem) => boolean;
}

const MobileNavigation: React.FC<MobileNavigationProps> = ({
  menuItems,
  isMobileMenuOpen,
  onCloseMobileMenu,
  isActiveItem,
}) => {
  return (
    <>
      {/* Mobile Navigation Overlay */}
      {isMobileMenuOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
          onClick={onCloseMobileMenu}
        />
      )}

      {/* Mobile Navigation Sidebar */}
      <div
        className={`fixed top-0 right-0 h-full w-full transform transition-transform duration-300 ease-in-out z-50 md:hidden bg-white ${
          isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        {/* Mobile Header */}
        <div className="flex items-center justify-end p-4 h-16 border-b bg-white border-b-secondary-200">
          <button
            onClick={onCloseMobileMenu}
            className="p-2 rounded-lg text-secondary-900 hover:opacity-80 transition-colors duration-200 cursor-pointer"
          >
            <XMarkIcon className="h-6 w-6" />
          </button>
        </div>

        {/* Mobile Menu Items */}
        <div className="py-4 px-2 overflow-y-auto h-full">
          <div className="space-y-1">
            {menuItems.map((item) => (
              <div key={item.label}>
                {item.href ? (
                  <Link
                    to={item.href}
                    className={`block px-4 py-3 text-base font-medium transition-all duration-200 cursor-pointer relative ${
                      isActiveItem(item)
                        ? 'text-primary-500 border-b-2 border-secondary-900'
                        : 'text-secondary-900 hover:border-b-2 hover:border-secondary-900 hover:text-primary-500'
                    }`}
                    onClick={onCloseMobileMenu}
                  >
                    {item.label}
                  </Link>
                ) : (
                  <span className="block px-4 py-3 text-base font-medium text-secondary-900">
                    {item.label}
                  </span>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileNavigation;
